module.exports = __webpack_public_path__ + "static/media/gurgaon-1.5b482ec1.jpg";